import { module as BaseModule } from 'modujs'
import Swiper from 'swiper'
import {
  Scrollbar, Pagination, Navigation, Autoplay,
} from 'swiper/modules'

import 'swiper/css' //eslint-disable-line
import 'swiper/css/scrollbar' //eslint-disable-line
import 'swiper/css/pagination' //eslint-disable-line

export default class extends BaseModule {
  init() {
    const slider = this.el.querySelector('[data-slider]')
    const { sliderConfig } = slider.dataset

    let reverseDirection
    if (sliderConfig === 'landing') {
      reverseDirection = slider.dataset.sliderReverse === '1'
    }

    const params = {
      frontpage: {
        modules: [Scrollbar],
        scrollbar: {
          el: '.swiper-scrollbar',
        },
        draggable: true,
        slidesPerView: 1.5,
        spaceBetween: 14,
        grabCursor: true,
        breakpoints: {
          768: {
            slidesPerView: 3.5,
            spaceBetween: 24,
          },
          1024: {
            slidesPerView: 4.5,
          },
        },
      },
      landing: {
        modules: [Autoplay],
        draggable: false,
        slidesPerView: 'auto',
        loop: true,
        grabCursor: false,
        autoplay: {
          delay: 5000,
          reverseDirection,
        },
      },
      product: {
        modules: [Pagination, Navigation],
        draggable: true,
        slidesPerView: 1,
        grabCursor: true,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
        },
        navigation: {
          nextEl: '.swiper-next',
          prevEl: '.swiper-prev',
        },
      },
      studio: {
        modules: [Scrollbar],
        scrollbar: {
          el: '.swiper-scrollbar',
        },
        draggable: true,
        slidesPerView: 'auto',
        spaceBetween: 14,
        grabCursor: true,
        breakpoints: {
          768: {
            spaceBetween: 24,
          },
        },
      },
    }

    // console.log(params[sliderConfig], sliderConfig)
    this.swiper = new Swiper(slider, params[sliderConfig])
    window.dispatchEvent(new CustomEvent('swiper:init'))
  }
}
